// src/components/Login/Login.jsx
import React, { useEffect, useState } from 'react';
import { useAuth } from "react-oidc-context";
import { useTranslation } from "react-i18next";
import loadingStyles from './../../styles/Common.module.css';

export default function Login({ isMobile, onClick }) {
  const { t } = useTranslation();
  const auth = useAuth();

  // 강제로 로그인 버튼을 보여줄지 여부
  const [showLoginButton, setShowLoginButton] = useState(false);

  // 에러 로그
  useEffect(() => {
    if (auth.error) {
      console.error("인증 오류 발생:", auth.error.message);
    }
  }, [auth.error]);

  // ✅ 타임아웃 로직 (유지)
  useEffect(() => {
    let timer;
    if (auth.isLoading) {
      timer = setTimeout(() => {
        // 현재 URL이 로그인 콜백(code 포함)인지 확인
        const params = new URLSearchParams(window.location.search);
        
        // 콜백 상황이 아니라면(단순 새로고침 지연 등), 1.5초 뒤 강제로 로그인 버튼 표시
        if (!params.has('code')) {
          setShowLoginButton(true);
        }
      }, 1500); 
    } else {
      // 로딩이 끝나면 상태 초기화
      setShowLoginButton(false);
    }
    return () => clearTimeout(timer);
  }, [auth.isLoading]);

  const handleSignIn = () => {
    if (onClick) onClick(); 
    auth.signinRedirect();
  };

  const handleSignOut = () => {
  if (onClick) onClick();
  
  // 현재 로그인된 사용자의 닉네임 체크 기록 삭제
  if (auth.user?.profile?.sub) {
      localStorage.removeItem(`nickname_checked_${auth.user.profile.sub}`);
  }
  
  auth.signoutRedirect();
};

  // ---------------- UI 렌더링 우선순위 ----------------

  // 1순위: 인증 완료 상태 -> 로그아웃 버튼 (가장 먼저 확인)
  if (auth.isAuthenticated) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        <button onClick={handleSignOut}>
          {t('loginComponent.logout')}
        </button>
      </div>
    );
  }

  // 2순위: 에러가 있거나, 타임아웃(1.5초)으로 인해 강제 표시 상태일 때 -> 로그인 버튼
  if (auth.error || showLoginButton) {
    return (
      <button onClick={handleSignIn}>
        {t('loginComponent.login')}
      </button>
    );
  }

  // 3순위: 로딩 중일 때 -> 스피너 버튼
  // (타임아웃 전이거나, 'code'가 있어 인증 진행 중인 경우 여기에 걸림)
  if (auth.isLoading) {
    return (
      <button disabled className={loadingStyles.loadingButtonWithSpinner}>
        <div className={loadingStyles.spinnerSmall}></div>
        {/* <span>{t('loginComponent.loading')}</span> */}
      </button>
    );
  }

  // 4순위: 그 외 기본 상태 -> 로그인 버튼
  return <button onClick={handleSignIn}>{t('loginComponent.login')}</button>;
}